import React from 'react';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import { reduxForm, formValueSelector } from 'redux-form';
import { isEqual } from 'lodash';
import {
  compose,
  withProps,
  withHandlers,
  withPropsOnChange,
} from 'recompose';
import { t } from '../../../../modules/infra/i18n';
import {
  openShopCashRegister,
  openBarberCashRegister,
} from '../actions';
import { syncValidateData } from '../../../common/validator';
import { withActionByRole } from '../../../common/helpers/actions';
import {
  getInitialDenominationValues,
  getBillCountsTotal,
} from '../helpers';
import OpenWithBillCounts from '../components/OpenWithBillCounts';
import confirmModal from '../../../common/confirmModal';
import Money from '../../../common/money';

const OPEN_REGISTER_FORM = 'open-cash-register';
const schema = Joi.object().keys({
  total: Joi.number(),
  billCounts: Joi.array().items(
    Joi.object().keys({
      denomination: Joi.number(),
      billsNo: Joi.number().optional(),
      isCoin: Joi.boolean().optional(),
      name: Joi.string().optional(),
      coinsPerRoll: Joi.number().optional(),
    })
  ),
});

const formSelector = formValueSelector(OPEN_REGISTER_FORM);
const form = reduxForm({
  form: OPEN_REGISTER_FORM,
  validate: values => syncValidateData(values, schema),
});

export default compose(
  connect(state => ({
    billCounts: formSelector(state, 'billCounts'),
    total: formSelector(state, 'total'),
  })),
  withActionByRole('openCashRegister', openShopCashRegister, openBarberCashRegister),
  withProps(() => ({
    initialValues: {
      billCounts: getInitialDenominationValues(),
      total: 0,
    },
  })),
  withHandlers({
    onSubmit: props => async (values) => {
      const confirmed = await confirmModal({
        type: 'yesno',
        title: t('register:cash_register.open_register_confirm_title'),
        message: (
          <div className="u-fontsize-normal">
            <div>
              {t('register:cash_register.open_register_confirm_message').replace('{{amount}}', '')}
              {' '}<Money>{values.total}</Money> balance?
            </div>
          </div>
        ),
        confirmButtonText: t('common:buttons.yes'),
        negativeButtonText: t('common:buttons.no'),
      });

      if (confirmed) {
        props.openCashRegister(values.total);
      }
    },
  }),
  form,
  withPropsOnChange(
    (props, nextProps) => !isEqual(props.billCounts, nextProps.billCounts),
    (props) => {
      if (props.billCounts) {
        props.change('total', getBillCountsTotal(props.billCounts));
      }
    },
  ),
)(OpenWithBillCounts);
